var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "margin-top": "120px" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "pageHeaderWrap",
          [
            _c("pageHeaderUpperText", [
              _c("i", { staticClass: "icon-action lnr lnr-book" }),
              _vm._v(" "),
              _c("span", [_vm._v("Поиск взаимосвязей между ЮЛ / ФЛ")]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "relations-search" }, [
          _c("div", { staticClass: "relations-search__input-form" }, [
            _c(
              "div",
              {
                staticClass:
                  "relations-search__form-block relations-search__form-block_buttons",
              },
              [
                _c("btn", { on: { click: _vm.clearAllSuggestions } }, [
                  _vm._v("Очистить"),
                ]),
                _vm._v(" "),
                _c(
                  "btn",
                  {
                    attrs: {
                      blue: "",
                      disabled: !(
                        _vm.hintSuggestion.to && _vm.hintSuggestion.from
                      ),
                    },
                    on: { click: _vm.searchConnections },
                  },
                  [_vm._v("Поиск")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "relations-search__form-block relations-search__form-block_input",
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.hintSuggestion.from
                  ? _c(
                      "div",
                      { staticClass: "relations-search__form-block_hinted" },
                      [
                        _c("i", {
                          staticClass: "lnr lnr-cross blue-red-hover-text",
                          on: {
                            click: function ($event) {
                              return _vm.clearSuggestions("from")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.hintSuggestion.from.name
                          ? _c(
                              "p",
                              { staticClass: "single-long-string-nowrap" },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.hintSuggestion.from.name)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hintSuggestion.from.inn
                          ? _c("p", [
                              _c("b", [_vm._v("ИНН: ")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.hintSuggestion.from.inn)),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _c(
                      "div",
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.from,
                              expression: "from",
                            },
                          ],
                          staticClass: "relations-search__input",
                          attrs: {
                            type: "text",
                            placeholder: "ЮЛ / ФЛ 1",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.from },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.from = $event.target.value
                              },
                              function ($event) {
                                return _vm.getSuggestions("from")
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.from
                          ? _c("i", {
                              staticClass: "lnr lnr-cross blue-red-hover-text",
                              on: {
                                click: function ($event) {
                                  return _vm.clearSuggestions("from")
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("relationsSuggestions", {
                          attrs: {
                            suggestions: _vm.suggestionsFrom,
                            setSuggestion: function (suggestion) {
                              _vm.setSuggestion(suggestion, "from")
                            },
                          },
                        }),
                      ],
                      1
                    ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "relations-search__form-block relations-search__form-block_input",
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _vm.hintSuggestion.to
                  ? _c(
                      "div",
                      { staticClass: "relations-search__form-block_hinted" },
                      [
                        _c("i", {
                          staticClass: "lnr lnr-cross blue-red-hover-text",
                          on: {
                            click: function ($event) {
                              return _vm.clearSuggestions("to")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.hintSuggestion.to.name
                          ? _c(
                              "p",
                              { staticClass: "single-long-string-nowrap" },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.hintSuggestion.to.name)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hintSuggestion.to.inn
                          ? _c("p", [
                              _c("b", [_vm._v("ИНН: ")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.hintSuggestion.to.inn)),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _c(
                      "div",
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.to,
                              expression: "to",
                            },
                          ],
                          staticClass: "relations-search__input",
                          attrs: {
                            type: "text",
                            placeholder: "ЮЛ / ФЛ 2",
                            autocomplete: "off",
                          },
                          domProps: { value: _vm.to },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.to = $event.target.value
                              },
                              function ($event) {
                                return _vm.getSuggestions("to")
                              },
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _vm.to
                          ? _c("i", {
                              staticClass: "lnr lnr-cross blue-red-hover-text",
                              on: {
                                click: function ($event) {
                                  return _vm.clearSuggestions("to")
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("relationsSuggestions", {
                          attrs: {
                            suggestions: _vm.suggestionsTo,
                            setSuggestion: function (suggestion) {
                              _vm.setSuggestion(suggestion, "to")
                            },
                          },
                        }),
                      ],
                      1
                    ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "relations-search__form-block rasporka" },
              [
                _vm._m(2),
                _vm._v(" "),
                _c("counter", {
                  staticStyle: { float: "right" },
                  attrs: { getNumCb: _vm.getNumCb, defaultNum: _vm.maxHops },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", "margin-top": "-15px" } },
              [
                _vm.maxHops <= 5
                  ? _c("em", [_vm._v("значимые взаимосвязи")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.maxHops >= 6 && _vm.maxHops <= 7
                  ? _c("em", [_vm._v("малозначимые взаимосвязи")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.maxHops >= 8
                  ? _c("em", [_vm._v("незначимые взаимосвязи")])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "relations-search__form-block relations-search__form-block_checkbox",
              },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.all_links,
                        expression: "all_links",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.all_links)
                        ? _vm._i(_vm.all_links, null) > -1
                        : _vm.all_links,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.all_links,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.all_links = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.all_links = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.all_links = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Показать все возможные связи")]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relations-search__network" },
            [
              _vm.relationsLoading ? _c("shestirenka-loader") : _vm._e(),
              _vm._v(" "),
              !_vm.relationsLoading
                ? _c("relationsNetwork", {
                    ref: "relations-search-network",
                    attrs: {
                      physics: true,
                      relations: [
                        _vm.hintSuggestion.from,
                        _vm.hintSuggestion.to,
                      ],
                      printAndDownloadHeaderText:
                        "Поиск взаимосвязей между ЮЛ / ФЛ",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("ЮЛ / ФЛ 1: ")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("b", [_vm._v("ЮЛ / ФЛ 2: ")])])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { float: "left" } }, [
      _c("span", [_vm._v("Искать взаимосвязи на")]),
      _vm._v(" "),
      _c("span", [_vm._v("расстоянии до")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }